import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes, PrivateClientGroup } from '@tassat/payments-definitions';

export interface PCGState {
    [key: string]: PrivateClientGroup; //PCG_ID as key
}

const initialState: PCGState = {};

const initialLoadAction = createAction<{ privateClientGroups: PCGState }>('InitialLoad');
const privateClientGroupAction = createAction<PrivateClientGroup>(CoreMsgTypes.PrivateClientGroup);

const privateClientGroupsSlice = createSlice({
    name: 'privateClientGroups',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (state, action) => {
                Object.assign(state, action.payload.privateClientGroups);
            })
            .addCase(privateClientGroupAction, (state, action) => {
                if (action.payload.IsDeleted) {
                    delete state[action.payload.PCGId];
                } else {
                    state[action.payload.PCGId] = action.payload;
                }
            });
    }
});

export default privateClientGroupsSlice.reducer;